import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsAddAnywayButton = (props: Props) => {
  const { isLoading, onPress } = props;

  return (
    <Button
      size="large-wide"
      style={styles.button}
      width="100%"
      palette="spinachMuted"
      isLoading={isLoading}
      onPress={onPress}
      accessibilityRole="button"
    >
      <FormattedMessage {...messages.addToBagAnyway} />
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
    borderWidth: 1,
    borderColor: theme.colors.KALE,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  addToBagAnyway: {
    defaultMessage: 'Add to bag anyway',
    description: 'Add To Bag | Unavailable ingredients | Add to bag anyway CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isLoading: boolean;
  onPress: () => void;
};
